import type { CityConfig } from "@/pages/city-template/types";

export const beloitConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — WI Dept of Health Services Vital Records", href: "https://www.dhs.wisconsin.gov/vitalrecords/", description: "Official Wisconsin vital records office in Madison" },
    { label: "Marriage Licenses — Rock County Clerk", href: "https://www.co.rock.wi.us", description: "Rock County Clerk — marriage license issuance" },
    { label: "Divorce Records — Rock County Clerk of Courts", href: "https://www.co.rock.wi.us", description: "Rock County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of WI DHS for online vital record orders" },
  ],
  city: "Beloit",
  state: "Wisconsin",
  stateAbbr: "WI",
  slug: "beloit",
  route: "/cities/beloit",
  title: "Emergency & Expedited Passport Services Beloit WI | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Beloit, WI — as fast as 24 hours. No Beloit passport agency. Fast Passport Center couriers to the Chicago Passport Agency at 101 Ida B Wells Dr, about 95 miles southeast via I-90. A+ BBB rated. Serving Beloit College students, Rock County families, and WI-IL border commuters.",
  h1: "Emergency & Expedited Passport Services in Beloit, WI",
  heroSubtitle: "Beloit sits right on the Wisconsin-Illinois border along the Rock River, home to Beloit College and a strong manufacturing tradition. Fast Passport Center's registered couriers deliver your documents to the Chicago Passport Agency at 101 Ida B Wells Dr so you get a new or renewed passport as fast as 24 hours — whether you're a Beloit College student heading abroad for a semester, a Rock County family planning a European vacation, or a border-area professional with international business travel.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beloit%20Wisconsin%20downtown%20with%20the%20Rock%20River%20flowing%20through%20and%20historic%20downtown%20buildings%20during%20warm%20golden%20hour%20sunset%2C%20Beloit%20College%20campus%20in%20distance%20with%20small%20Wisconsin%20city%20charm%2C%20wide%20angle%20professional%20photography%20with%20clean%20composition&width=1800&height=700&seq=beloit-wi-hero-001&orientation=landscape",
  heroImageAlt: "Beloit Wisconsin downtown with Rock River and Beloit College campus at golden hour",
  geoPosition: "42.5083;-89.0318",
  geoPlacename: "Beloit, Wisconsin",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, Chicago, IL 60605",
    distance: "Approximately 95 miles from Beloit — about 1 hour 30 minutes via I-90",
  },
  nearbyCitiesZips: [
    { name: "Beloit", zips: "53511" },
    { name: "South Beloit", zips: "61080" },
    { name: "Janesville", zips: "53545, 53546" },
    { name: "Delavan", zips: "53115" },
    { name: "Clinton", zips: "53525" },
    { name: "Sharon", zips: "53585" },
    { name: "Darien", zips: "53114" },
    { name: "Orfordville", zips: "53576" },
    { name: "Walworth", zips: "53184" },
    { name: "Elkhorn", zips: "53121" },
    { name: "Milton", zips: "53563" },
    { name: "Edgerton", zips: "53534" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Chicago Passport Agency — only 95 miles from Beloit via I-90" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "WI-IL Border Hub", desc: "Serving Beloit, South Beloit, Janesville, and all Rock County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Beloit case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Chicago IL", route: "/cities/chicago" },
    { name: "Expedited passport in Milwaukee WI", route: "/cities/milwaukee" },
    { name: "Urgent passport in Beloit WI", route: "/cities/beloit" },
    { name: "Wisconsin passport hub", route: "/states/wisconsin" },
    { name: "Fast passport in Janesville WI", route: "/cities/janesville" },
    { name: "Expedited passport in Madison WI", route: "/cities/madison-wi" },
    { name: "Emergency passport in Racine WI", route: "/cities/racine" },
  ],
  fpcOfficeAddress: "101 Ida B Wells Dr, Chicago, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Beloit remotely via secure courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency at 101 Ida B Wells Dr — approximately 95 miles southeast. Beloit's location directly on I-90, the primary corridor between Madison and Chicago, makes overnight courier routing exceptionally efficient. Of all Wisconsin cities served, Beloit is among the closest to the Chicago Passport Agency, and our dedicated agents ensure Rock County travelers never need to make the drive themselves.",
  fpcOfficeDistance: "Serving all of Rock County",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Beloit, Janesville, Delavan, and the greater Rock County area. From Beloit College students heading abroad to Rock County families planning international trips, we help southern Wisconsin border-area travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Beloit and nearby communities including South Beloit (IL), Janesville, Delavan, Clinton, Darien, and the entire Rock County area.",
  howItWorksIntro: "Most Beloit travelers complete everything online and ship documents overnight. At only 95 miles from Chicago, Fast Passport Center provides exceptionally fast courier turnaround for Rock County residents — eliminating the 1.5-hour drive to the Chicago Passport Agency.",
  mistakesIntro: "Beloit travelers, including Beloit College students and WI-IL border commuters, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Beloit and Rock County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Beloit? Here are the most common ones we hear from Rock County and border-area travelers.",
  statePageRoute: "/states/wisconsin",
  statePageName: "Wisconsin",
  dmvWebsite: "https://wisconsindot.gov/Pages/dmv/license-drvs/how-to-apply.aspx",
  dmvLabel: "Wisconsin DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 101 Ida B Wells Dr",
        "Life-or-death emergencies only",
        "95 miles to Chicago (1 hour 30 minutes via I-90)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Beloit College students studying abroad",
        "Perfect for Rock County family vacations",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from ORD",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Beloit is only 95 miles from the Chicago Passport Agency — our courier service delivers rapid turnaround for Rock County travelers via I-90.",
      bullets: ["Rock County WI-IL border coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Rock County",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Beloit adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Beloit and Rock County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Beloit and Rock County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Beloit and Rock County residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Chicago agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Rock County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Rock County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Beloit WI", description: "Urgent passport processing for Beloit, WI travelers via Chicago Passport Agency courier — 95 miles from Beloit." },
    { name: "Passport Renewal Beloit WI", description: "Fast passport renewal for Beloit and Rock County, Wisconsin residents." },
    { name: "New Passport Beloit WI", description: "First-time passport application assistance for Beloit and Rock County area residents." },
    { name: "Lost Passport Beloit WI", description: "Passport replacement for lost or stolen passports for Beloit and Rock County residents." },
    { name: "Child Passport Beloit WI", description: "Minor passport services for Beloit and Rock County families." },
    { name: "Name Change Passport Beloit WI", description: "Passport name change service for Beloit, WI residents." },
  ],
  testimonials: [
    {
      name: "Olivia R.",
      location: "Beloit College Student",
      rating: 5,
      text: "I'm an anthropology major at Beloit College and got accepted to a field research program in Peru. Realized 14 days before departure I needed my first passport. Fast Passport Center guided me through the DS-11 process and delivered in 5 business days. The border-area proximity to Chicago made everything incredibly fast.",
      service: "First-Time Passport",
    },
    {
      name: "Greg & Linda M.",
      location: "Beloit, WI",
      rating: 5,
      text: "Rock County couple planning a retirement trip to Spain and Portugal. We both needed renewals with 4 weeks before departure. Fast Passport Center handled both in 6 business days. Beloit's proximity to Chicago on I-90 made the courier turnaround lightning fast.",
      service: "Dual Renewal",
    },
    {
      name: "Carlos V.",
      location: "South Beloit, IL",
      rating: 5,
      text: "South Beloit resident who works in manufacturing and needed a passport for a last-minute supplier visit to Mexico. Realized my passport was expired 7 days before the trip. Fast Passport Center expedited my renewal in 3 business days through Chicago. Made the trip without issue.",
      service: "Emergency Renewal",
    },
    {
      name: "Diana H.",
      location: "Janesville, WI",
      rating: 5,
      text: "Janesville resident and single mom who needed passports for myself and two kids for a spring break trip to the Bahamas. Fast Passport Center walked us through the child passport process and had all three passports back in 8 business days. Our agent was incredibly patient with my questions.",
      service: "Family Applications",
    },
  ],
  facilities: [
    {
      id: "bel-1",
      name: "Beloit Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 Mill St",
      city: "Beloit",
      state: "WI",
      zip: "53511",
      phone: "(608) 365-5930",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Beloit — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Beloit and Rock County residents. Appointment required. Located downtown near the Rock River.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-2",
      name: "Rock County Clerk Office",
      type: "County Clerk Passport Acceptance",
      address: "51 S Main St",
      city: "Janesville",
      state: "WI",
      zip: "53545",
      phone: "(608) 757-5660",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Janesville — 15 miles north",
      website: "https://www.co.rock.wi.us",
      websiteLabel: "Rock County",
      notes: "Full passport acceptance services at the Rock County Courthouse in Janesville. Convenient for county-wide residents.",
      icon: "ri-government-line",
    },
    {
      id: "bel-3",
      name: "Janesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1818 Milton Ave",
      city: "Janesville",
      state: "WI",
      zip: "53545",
      phone: "(608) 754-6554",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Janesville — 15 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger USPS facility with passport acceptance services. Convenient for Janesville and northern Rock County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-4",
      name: "South Beloit Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "205 Oak Grove Ave",
      city: "South Beloit",
      state: "IL",
      zip: "61080",
      phone: "(815) 389-3046",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Beloit — 2 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for WI-IL border residents in South Beloit. Located just across the state line.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-5",
      name: "Delavan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "335 E Walworth Ave",
      city: "Delavan",
      state: "WI",
      zip: "53115",
      phone: "(262) 728-3555",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Delavan — 18 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Delavan and Walworth County border-area residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-6",
      name: "Clinton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "231 Allen St",
      city: "Clinton",
      state: "WI",
      zip: "53525",
      phone: "(608) 676-4511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Clinton — 10 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small-town option for Clinton and eastern Rock County residents. Call ahead — limited hours may vary.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Chicago Agency", agency: "95 miles — 1 hour 30 minute drive on I-90, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Crossing State Lines for the Wrong Facility",
      description: "Beloit's unique location right on the WI-IL border creates confusion about jurisdiction. Some residents drive to Illinois post offices thinking they'll get faster service, only to face the same processing times. Passport applications follow federal rules regardless of which state you apply in. Fast Passport Center serves both sides of the state line equally.",
    },
    {
      icon: "ri-calendar-line",
      title: "Beloit College Students Waiting Until Break",
      description: "Beloit College students accepted to study abroad or field research programs often wait until semester break to handle passports — right when acceptance facilities are flooded with other student applications. Start your passport process 3-4 months before your program departure, ideally during the prior semester.",
    },
    {
      icon: "ri-route-line",
      title: "Assuming I-90 Construction Means You Should Drive Local Routes",
      description: "Beloit residents sometimes avoid I-90 due to ongoing construction and try to take back roads to Chicago — turning a 1.5-hour drive into 3+ hours. Our courier service navigates I-90 construction patterns daily and always uses the fastest available route, making the drive irrelevant for Beloit travelers.",
    },
    {
      icon: "ri-restart-line",
      title: "Not Checking Passport Validity Before Booking International Flights",
      description: "Rock County travelers often book international flights from Chicago O'Hare months in advance without checking passport expiration dates. Most countries require 6 months passport validity beyond your return date. If your passport expires within 6 months of travel, airlines may deny boarding.",
    },
    {
      icon: "ri-image-line",
      title: "Using Beloit College Student ID Photos as Passport Photos",
      description: "Beloit College students sometimes try to use campus ID photos or self-taken phone photos for passport applications. Passport photos must be exactly 2x2 inches with a pure white background, neutral expression, and no glasses. Only professional passport photo services meet U.S. Department of State standards.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When In-Person Is Required",
      description: "Rock County residents with passports that expired more than 5 years ago, were issued under age 16, or have a name change without documentation must use Form DS-11 (in-person application) — not DS-82 (mail-in). Filing the wrong form means your application gets rejected and you start over.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Beloit, Janesville, or South Beloit." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Chicago Passport Agency — only 95 miles southeast via I-90." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Chicago Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Beloit or Rock County address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Beloit from the Chicago passport agency?",
      a: "Beloit is approximately 95 miles from the Chicago Passport Agency at 101 Ida B Wells Dr — about a 1 hour 30 minute drive southeast via I-90. This makes Beloit one of the closest Wisconsin cities to the Chicago Passport Agency, second only to Kenosha and Racine. However, the Chicago agency still requires pre-scheduled appointments and does not accept walk-ins.",
    },
    {
      q: "Does Beloit, WI have its own passport agency?",
      a: "No. Beloit does not have a passport agency. The closest passport agency is the Chicago Passport Agency at 101 Ida B Wells Dr, about 95 miles southeast. Beloit has passport acceptance facilities — the Beloit Post Office at 300 Mill St and the Rock County Clerk's office in Janesville — which can accept your DS-11 application but cannot process or expedite it.",
    },
    {
      q: "Can I use a passport acceptance facility in Illinois since Beloit is on the border?",
      a: "Yes, you can use any U.S. passport acceptance facility regardless of which state you reside in. The South Beloit Post Office just across the state line accepts passport applications from Wisconsin residents. However, all acceptance facilities have the same processing limitations — they accept and forward applications but cannot expedite processing. Fast Passport Center's courier service works regardless of which state you're in.",
    },
    {
      q: "I'm a Beloit College student — how fast can I get a passport for study abroad?",
      a: "Beloit College students heading to study abroad or field research programs are frequent clients. Emergency processing delivers passports in 24–48 hours. Standard expedited processing runs 2–9 business days. Beloit's 95-mile proximity to Chicago makes it one of the fastest courier routes in Wisconsin. Start the process at least 2-3 months before your program.",
    },
    {
      q: "Where do Beloit travelers typically fly internationally?",
      a: "Beloit travelers typically fly from Chicago O'Hare International Airport (ORD, about 95 miles southeast via I-90) or Chicago Rockford International Airport (RFD, about 30 miles south). ORD offers extensive global routes while RFD provides limited domestic and seasonal international service. Milwaukee Mitchell (MKE) is about 75 miles northeast.",
    },
    {
      q: "How fast can I get an emergency passport in Beloit?",
      a: "Emergency processing is typically 24–48 hours for Beloit residents. Beloit's location directly on I-90 makes it one of the fastest courier routes from Wisconsin to Chicago. Of all Wisconsin cities, Beloit has among the shortest courier turnaround times to the Chicago Passport Agency.",
    },
    {
      q: "Where can I get passport photos in Beloit?",
      a: "Walgreens at 1811 Prairie Ave and CVS Pharmacy at 1899 E Liberty Ln in Beloit offer passport photo services. The UPS Store at 2840 Milwaukee Rd also provides photos. Beloit College campus photo services may not meet U.S. Department of State standards — use a professional passport photo service.",
    },
    {
      q: "Can the Rock County Clerk's office in Janesville process my passport?",
      a: "Yes. The Rock County Clerk's office at 51 S Main St in Janesville accepts passport applications as a passport acceptance facility. They can accept DS-11 applications and verify your documents. Call (608) 757-5660 before visiting to confirm current passport service hours.",
    },
    {
      q: "How do I renew my passport in Beloit?",
      a: "Adult renewals meeting all DS-82 eligibility criteria (16 or older, issued within 15 years, same name) can be done entirely by mail. Fast Passport Center's courier service achieves 2–9 business day turnaround — far faster than self-service USPS (8–11 weeks). If you're not eligible for mail-in renewal, visit the Beloit Post Office or Rock County Clerk for an in-person DS-11 application.",
    },
    {
      q: "Does the Beloit Post Office take walk-in passport appointments?",
      a: "The Beloit Post Office at 300 Mill St accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (608) 365-5930 to schedule. The post office is often busiest during lunch hours and late afternoons.",
    },
    {
      q: "Can Fast Passport Center help Janesville and Delavan residents too?",
      a: "Absolutely. We serve all of Rock County and surrounding communities including Janesville, Delavan, South Beloit (IL), Clinton, Darien, Walworth, Elkhorn, Milton, and Edgerton. Residents of surrounding communities never need to drive to Beloit or Chicago for service.",
    },
    {
      q: "Why is Beloit's courier route faster than other Wisconsin cities?",
      a: "Beloit's location directly on I-90, about 95 miles from Chicago, makes it one of the fastest Wisconsin courier routes. Unlike cities in northern Wisconsin that are 200+ miles from the agency, Beloit's proximity means documents arrive at the Chicago Passport Agency faster, often resulting in same-day submission for early overnight shipments. This is a significant advantage for Beloit and Rock County travelers.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Beloit", address: "1811 Prairie Ave, Beloit, WI 53511", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Beloit", address: "1899 E Liberty Ln, Beloit, WI 53511", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Beloit", address: "2840 Milwaukee Rd, Beloit, WI 53511", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart Photo — Beloit", address: "2785 Milwaukee Rd, Beloit, WI 53511", hours: "Mon–Sun: 7AM–9PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Janesville", address: "1717 Milton Ave, Janesville, WI 53545", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Janesville", address: "1700 E Court St, Janesville, WI 53545", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    { name: "WI DMV — Janesville", address: "2506 Humes Rd, Janesville, WI 53545", hours: "Mon–Fri: 7:00AM–5:00PM", note: "Full-service DMV center for Rock County. REAL ID, driver's license, and state ID services. About 15 miles north of Beloit.", featured: true },
    { name: "WI DMV — Delavan", address: "114 S 7th St, Delavan, WI 53115", hours: "Mon–Fri: 7:00AM–5:00PM", note: "Serves Walworth County and eastern Rock County residents. About 18 miles east of Beloit.", featured: false },
    { name: "IL DMV — Rockford", address: "3720 E State St, Rockford, IL 61108", hours: "Mon–Fri: 8:00AM–5:30PM", note: "For Illinois residents in South Beloit and border areas. About 25 miles south of Beloit.", featured: false },
  ],
  airports: [
    {
      code: "RFD",
      name: "Chicago Rockford International Airport",
      distance: "30 miles south of Beloit",
      address: "2 Airport Cir, Rockford, IL 61109",
      note: "Closest airport to Beloit. Domestic cargo hub with limited seasonal passenger service. About 35 minutes south. Primarily used for cargo — ORD and MKE are preferred for passenger international travel.",
      flightUrl: "https://flyrfd.com/",
      flightLabel: "RFD Airport",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "95 miles southeast of Beloit",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international gateway with extensive global routes. About 1 hour 30 minutes southeast via I-90. Co-located near Chicago Passport Agency. Primary international airport for Beloit travelers.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Airport",
      featured: false,
    },
    {
      code: "MKE",
      name: "Milwaukee Mitchell International Airport",
      distance: "75 miles northeast of Beloit",
      address: "5300 S Howell Ave, Milwaukee, WI 53207",
      note: "Wisconsin's busiest airport with domestic routes and some international service. About 1 hour 15 minutes northeast via I-43.",
      flightUrl: "https://www.mitchellairport.com/",
      flightLabel: "MKE Airport",
      featured: false,
    },
    {
      code: "MSN",
      name: "Dane County Regional Airport",
      distance: "50 miles north of Beloit",
      address: "4000 International Ln, Madison, WI 53704",
      note: "Madison's airport with domestic routes via major carriers. About 50 minutes north via I-90. Convenient alternative for Rock County travelers.",
      flightUrl: "https://www.msnairport.com/",
      flightLabel: "MSN Airport",
      featured: false,
    },
  ],
};